import React, { FC, useState, memo, useRef, CSSProperties } from 'react';
import styles from '../../styles/pitCheckbox.module.scss';
type BaseType = string | number | boolean;
interface ChangeFunc {
  (value: BaseType): any;
}
interface PitCheckboxProps {
  value: BaseType;
  label?: BaseType;
  disabled?: boolean;
  indeterminate?: boolean;
  onChange: ChangeFunc;
  style?: CSSProperties;
}
const PitCheckbox: FC<PitCheckboxProps> = memo(
  ({ value, label, disabled, indeterminate, onChange }) => {
    let [model, setModel] = useState(value);
    const handleChange = () => {
      setModel(!value);
      onChange && onChange(!value);
    };
    const checkboxRef = useRef(null);
    return (
      <label
        className={`${styles['pit-checkbox']} ${
          model ? styles['pit-checkbox-checked'] : ''
        } ${disabled ? styles['pit-checkbox-disabled'] : ''} ${
          indeterminate ? styles['pit-checkbox-indeterminate'] : ''
        } myCheckbox`}
      >
        <span className={styles['pit-checkbox__input']}>
          <span className={styles['pit-checkbox__inner']}></span>
          <input
            ref={checkboxRef}
            className={styles['pit-checkbox-original']}
            value={value as string}
            type="checkbox"
            aria-hidden="true"
            onChange={handleChange}
            tabIndex={-1}
            disabled={disabled}
          />
        </span>
        <span className={styles['pit-checkbox__label']}>
          <slot>{label || ''}</slot>
        </span>
      </label>
    );
  }
);
export default PitCheckbox;
